/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, OnDestroy } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { TranslateService } from "@ngx-translate/core";
import { NbAuthService } from "@nebular/auth";
import "rxjs-compat/add/operator/first";
import { AuthenticationService } from "./Services/authentication/authentication.service";
import { AppSettings } from "./configs/app-settings.config";
import { VehicleExpiredService } from "./Services/vehicle/vehicle-expired.service";
import { ProblemsService } from "./Services/vehicle/oc-cards/problems.service";
import { WorkScheduleProposalService } from "./Services/schedule/work-schedule-proposal.service";
import { PrescriptionsService } from "./Services/prescriptions/prescriptions.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private translate: TranslateService,
    private problemService: ProblemsService,
    private authService: AuthenticationService,
    private nbAuth: NbAuthService,
    private vehicleExpiredService: VehicleExpiredService,
    private workScheduleProposalService: WorkScheduleProposalService,
    private prescriptionService: PrescriptionsService
  ) {}

  ngOnInit() {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang("pl");

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use("pl");

    this.analytics.trackPageViews();

    this.checkLoginSession();

    this.checkExpirationDatesForVehicle();
  }

  checkExpirationDatesForVehicle() {
    this.checkExpirationDateForVehicleInterval();
    setInterval(() => {
      this.checkExpirationDateForVehicleInterval();
    }, 1000 * 60 * 60 * 24);
  }
  checkExpirationDateForVehicleInterval() {
    this.authService.getRoles().subscribe((res: any) => {
      if (!res.includes(AppSettings.GUEST))
        this.problemService.getWaitingCount();
      if (!res.includes(AppSettings.GUEST))
        this.workScheduleProposalService.GetAcceptedCount();
      if (!res.includes(AppSettings.GUEST))
        this.prescriptionService.GetPendingCount();
      if (this.authService.roleMatch(res, AppSettings.ADMIN)) {
        this.vehicleExpiredService.checkExpiration();
      }
    });
  }
  checkLoginSession() {
    this.authService
      .isAuthorized()
      .first()
      .subscribe(
        (res) => {},
        (err) => {
          this.nbAuth
            .logout("email")
            .first()
            .subscribe((res) => {});
        }
      );
  }
}
